export default __webpack_public_path__ + "static/media/house-11.39418320.jpeg";